/** @fileoverview Keeps the sign-in check value for a hosted app in session storage. */

const APP_CHECK_KEY = 'fabrik-app-check';
const CHECK_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Returns true when the value has the shape of a UUID. */
export const isValidCheck = (value: string) => CHECK_PATTERN.test(value);

/** Creates a new check value and stores it for this browser tab. */
export const createStoredCheck = () => {
  const check = crypto.randomUUID();
  try {
    sessionStorage.setItem(APP_CHECK_KEY, check);
  } catch {
    // Storage can be blocked. The return step will then fail the check safely.
  }
  return check;
};

/** Reads the stored check value and removes it so it can only be used once. */
export const takeStoredCheck = () => {
  try {
    const stored = sessionStorage.getItem(APP_CHECK_KEY) ?? '';
    sessionStorage.removeItem(APP_CHECK_KEY);
    return stored;
  } catch {
    return '';
  }
};
